import React from 'react';
import '../styles/landing.css';

const About = () => {
  return (
    <div className="page-about">
      {/* Page Header */}
      <section className="page-header">
        <span className="page-header__eyebrow">Who We Are</span>
        <h1 className="page-header__title">About Record News</h1>
        <p className="page-header__subtitle">
          Blending technology and media intelligence to transform print media monitoring into actionable insights.
        </p>
      </section>

      <div className="about-content container">
        <section className="about-block" style={{ '--delay': '0ms' }}>
          <div className="about-block__marker">01</div>
          <div className="about-block__body">
            <h2 className="about-block__title">Our Story</h2>
            <p>
              At Record News, we blend the power of technology and media intelligence to transform print media monitoring into actionable insights. Leveraging the latest advancements in data analytics, machine learning, and Python programming, we provide businesses with deep, data-driven insights from print media sources — helping them make informed decisions with precision.
            </p>
          </div>
        </section>

        <section className="about-block" style={{ '--delay': '80ms' }}>
          <div className="about-block__marker">02</div>
          <div className="about-block__body">
            <h2 className="about-block__title">Why Choose Us?</h2>
            <p>
              We don't just collect data — we decode it. By combining programmatic analysis with human expertise, we turn raw media content into clear, actionable intelligence that drives smarter business strategies. Whether you're a corporation, PR agency, or research firm, our technology ensures you stay ahead in an ever-evolving media landscape.
            </p>
          </div>
        </section>

        <section className="about-block" style={{ '--delay': '160ms' }}>
          <div className="about-block__marker">03</div>
          <div className="about-block__body">
            <h2 className="about-block__title">Our Expertise</h2>
            <p>
              From advanced print media monitoring with unparalleled accuracy, to AI-powered NLP and machine learning for trend extraction and sentiment analysis, to customised automated reporting and cutting-edge OCR for digitised print media — we stay ahead of the curve to give you a competitive edge.
            </p>
          </div>
        </section>

        <section className="about-block" style={{ '--delay': '240ms' }}>
          <div className="about-block__marker">04</div>
          <div className="about-block__body">
            <h2 className="about-block__title">Why We're Different</h2>
            <p>
              While others rely on outdated methods, we use Python scripting, predictive modelling, and big data processing to turn media noise into strategic foresight. Whether it's crisis management, competitor benchmarking, or trend forecasting, we provide the speed and depth modern businesses demand.
            </p>
          </div>
        </section>

        {/* Team */}
        <section className="team-section">
          <h2 className="team-section__title">Meet Our Team</h2>
          <div className="team-grid">
            {[
              { name: 'John Doe', role: 'CEO & Founder', initial: 'JD' },
              { name: 'Jane Smith', role: 'CTO', initial: 'JS' },
              { name: 'Mike Johnson', role: 'Lead Developer', initial: 'MJ' },
            ].map((member, i) => (
              <div className="team-card" key={member.name} style={{ '--delay': `${i * 100}ms` }}>
                <div className="team-card__avatar">{member.initial}</div>
                <h3 className="team-card__name">{member.name}</h3>
                <p className="team-card__role">{member.role}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
